export const toCreateEmployeePayload = (employee: any) => {
  return {
    employee_avatar: employee.employee_avatar, // 'default.png',
    typeDocument: employee.document_type?.value,
    document_number: employee.document_number?.toString(),
    expedition_place: employee.expedition_place,
    name: employee.name,
    last_name: employee.last_name,
    birthdate: employee.date_of_birth,
    gender: employee.gender?.value,
    civil_status: employee.civil_status?.value,
    landline: employee.landline,
    cell_phone: employee.cell_phone?.toString(),
    whatsapp: Number(employee.whatsapp),
    rh: employee.rh?.value,
    dominance: employee.dominance?.value,
    allergies: employee.allergies,
    cedula_name_saved_name: employee.cedula_name_saved_name,
    housing_type: employee.housing_type?.value,
    address: employee.address,
    neighborhood: employee.neighborhood,
    stratum: employee.stratum?.toString(),
    cost_center: employee.cost_center?.value,
    compani: employee.compani?.value,
    work_headquarters: employee.work_headquarters?.value,
    position: employee.cargo?.value,
    scholarship: employee.scholarship?.value,
    institution: employee.institution,
    degree: employee.degree,
    email: employee.email,
    contract: employee.type_contract?.value,
    salary_base: employee.salary_base,
    transport_subsidy: Number(employee.transport_subsidy),
    paymentMethods: employee.payment_method?.value,
    paymentFrecuencies: employee.frecuency_payment?.value,
    associatedBank: employee.associated_bank?.value,
    account_number: employee.account_number,
    file_certificate_bank_name: employee.certificate_banck_name_saved_name,
    vacation_acumulate: employee.vacation_acumulate,
    bonification_aditional: employee.bonification_aditional,
    date_start_contract: employee.date_start_contract,
    lunes: Number(employee.lunes),
    martes: Number(employee.martes),
    miercoles: Number(employee.miercoles),
    jueves: Number(employee.jueves),
    viernes: Number(employee.viernes),
    sabado: Number(employee.sabado),
    domingo: Number(employee.domingo),
    festivo: Number(employee.festivo),
    eps: employee.eps?.value,
    familyCompensationFund: employee.familyCompensation?.value,
    file_family_compensation_fund: employee.caja_compensacion_name_saved,
    saving: employee.cesantias?.value,
    file_savings: employee.cesantias_name_saved,
    retirement: employee.pension?.value,
    arl_name_saved: employee.arl_name_saved,
    vista_domiciliaria: Number(employee.vista_domiciliaria),
    visita_domiciliaria_name_saved: employee.visita_domiciliaria_name_saved,
    prueba_psicotecnica: Number(employee.prueba_psicotecnica),
    psicotecnica_name_saved: employee.psicotecnica_name_saved,
    manipulacion_alimentos: Number(employee.manipulacion_alimentos),
    manipulacion_alimentos_name_saved: employee.manipulacion_alimentos_name_saved,
    encuesta_dme: Number(employee.encuesta_dme),
    encuesta_dme_name_saved: employee.encuesta_dme_name_saved,
    trabajo_alturas: Number(employee.trabajo_alturas),
    trabajo_altura_name_saved: employee.trabajo_altura_name_saved,
    examen_medico: Number(employee.examen_medico),
    examen_medico_name_saved: employee.examen_medico_name_saved,
    contrato: Number(employee.contrato),
    certificado_estudios: Number(employee.certificado_estudios),
    certificado_estudios_name_saved: employee.certificado_estudios_name_saved,
    certificado_laboral: Number(employee.certificado_laboral),
    certificado_laboral_name_saved: employee.certificado_laboral_name_saved,
    verificacion_adres: Number(employee.verificacion_adres),
    verificacion_adres_name_saved: employee.verificacion_adres_name_saved,
    antecedentes: Number(employee.antecedentes),
    antecedentes_name_saved: employee.antecedentes_name_saved,
    entrevista: Number(employee.entrevista),
    entrevista_name_saved: employee.entrevista_name_saved,
    sociodemografica: Number(employee.sociodemografica),
    sociodemografica_name_saved: employee.sociodemografica_name_saved,
    compromiso_sst: Number(employee.compromiso_sst),
    compromiso_sst_name_saved: employee.compromiso_sst_name_saved,
    cv_name_saved_name: employee.cv_name_saved_name,
    file_signed_contract_name: employee.file_signed_contract_name,
    beneficiaries: employee.family || [],
    dotaciones: employee.items || [],
  };
};

export const toEditEmployeePayload = (employee: any) => {
  console.log("MAPPING EDIT PAYLOAD: ", employee.e_cedula_name_saved_name, employee);
  return {
    empleadoId: employee.empleadoId,
    typeDocument: employee.e_document_type?.value,
    document_number: employee.e_document_number?.toString(),
    expedition_place: employee.e_expedition_place,
    name: employee.e_name,
    last_name: employee.e_last_name,
    birthdate: employee.e_date_of_birth,
    gender: employee.e_gender?.value,
    civil_status: employee.e_civil_status?.value,
    landline: employee.e_landline,
    cell_phone: employee.e_cell_phone?.toString(),
    whatsapp: Number(employee.e_whatsapp),
    rh: employee.e_rh?.value,
    dominance: employee.e_dominance?.value,
    allergies: employee.e_allergies,
    cedula_name_saved_name: employee.e_cedula_name_saved_name,
    housing_type: employee.e_housing_type?.value,
    address: employee.e_address,
    neighborhood: employee.e_neighborhood,
    stratum: employee.e_stratum?.toString(),
    cost_center: employee.e_cost_center?.value,
    compani: employee.e_compani?.value,
    work_headquarters: employee.e_work_headquarters?.value,
    position: employee.e_cargo?.value,
    scholarship: employee.e_scholarship?.value,
    institution: employee.e_institution,
    degree: employee.e_degree,
    email: employee.e_email,
    contract: employee.e_type_contract ? employee.e_type_contract.value : null,
    salary_base: employee.e_salary_base,
    transport_subsidy: Number(employee.e_transport_subsidy),
    paymentMethods: employee.e_payment_method && employee.e_payment_method.value ? employee.e_payment_method.value : null,
    paymentFrecuencies: employee.e_frecuency_payment && employee.e_frecuency_payment.value ? employee.e_frecuency_payment.value : null,
    associatedBank: employee.e_associated_bank && employee.e_associated_bank.value ? employee.e_associated_bank.value : null,
    account_number: employee.e_account_number,
    file_certificate_bank_name: employee.e_certificate_banck_name_saved_name,
    vacation_acumulate: employee.e_vacation_acumulate,
    bonification_aditional: employee.e_bonification_aditional,
    date_start_contract: employee.e_date_start_contract,
    lunes: Number(employee.e_lunes),
    martes: Number(employee.e_martes),
    miercoles: Number(employee.e_miercoles),
    jueves: Number(employee.e_jueves),
    viernes: Number(employee.e_viernes),
    sabado: Number(employee.e_sabado),
    domingo: Number(employee.e_domingo),
    festivo: Number(employee.e_festivo),
    eps: employee.e_eps?.value,
    familyCompensationFund: employee.e_familyCompensation && employee.e_familyCompensation.value ? employee.e_familyCompensation.value : null,
    file_family_compensation_fund: employee.e_caja_compensacion_name_saved,
    saving: employee.e_cesantias && employee.e_cesantias.value ? employee.e_cesantias.value : null,
    file_savings: employee.e_cesantias_name_saved,
    retirement: employee.e_pension && employee.e_pension.value ? employee.e_pension.value : null,
    arl_name_saved: employee.e_arl_name_saved,
    vista_domiciliaria: Number(employee.e_vista_domiciliaria),
    visita_domiciliaria_name_saved: employee.e_visita_domiciliaria_name_saved,
    prueba_psicotecnica: Number(employee.e_prueba_psicotecnica),
    psicotecnica_name_saved: employee.e_psicotecnica_name_saved,
    manipulacion_alimentos: Number(employee.e_manipulacion_alimentos),
    manipulacion_alimentos_name_saved: employee.e_manipulacion_alimentos_name_saved,
    encuesta_dme: Number(employee.e_encuesta_dme),
    encuesta_dme_name_saved: employee.e_encuesta_dme_name_saved,
    trabajo_alturas: Number(employee.e_trabajo_alturas),
    trabajo_altura_name_saved: employee.e_trabajo_altura_name_saved,
    examen_medico: Number(employee.e_examen_medico),
    examen_medico_name_saved: employee.e_examen_medico_name_saved,
    contrato: Number(employee.e_contrato),
    certificado_estudios: Number(employee.e_certificado_estudios),
    certificado_estudios_name_saved: employee.e_certificado_estudios_name_saved,
    certificado_laboral: Number(employee.e_certificado_laboral),
    certificado_laboral_name_saved: employee.e_certificado_laboral_name_saved,
    verificacion_adres: Number(employee.e_verificacion_adres),
    verificacion_adres_name_saved: employee.e_verificacion_adres_name_saved,
    antecedentes: Number(employee.e_antecedentes),
    antecedentes_name_saved: employee.e_antecedentes_name_saved,
    entrevista: Number(employee.e_entrevista),
    entrevista_name_saved: employee.e_entrevista_name_saved,
    sociodemografica: Number(employee.e_sociodemografica),
    sociodemografica_name_saved: employee.e_sociodemografica_name_saved,
    compromiso_sst: Number(employee.e_compromiso_sst),
    compromiso_sst_name_saved: employee.e_compromiso_sst_name_saved,
    cv_name_saved_name: employee.e_cv_name_saved_name,
    file_signed_contract_name: employee.e_file_signed_contract_name,
    beneficiaries: employee.family || [],
    dotaciones: employee.items || [],
  };
};
